export default __webpack_public_path__ + "static/millingvideo-comp-004d849edca29989f32933c003174e3f.mp4";